export enum UserArtworkSalesSettingsAction {
  SetItemSalesType = 'setItemSalesType',
  SetAcceptablePrice = 'setAcceptablePrice',
  SetCanParticipateEvent = 'setCanParticipateEvent',
  SetAll = 'setAll',
}
